document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
  if($('.product').length){
    $('.product').each(function(){
        const $product = $(this);
        const productId = $product.find('span[data-micro="sku"]').text().trim();
        if($(this).find('.widget-parameter-wrapper').length){
            $(this).find('.name').after($(this).find('.widget-parameter-wrapper'));
        }
        else{
          $(this).find('.name').after('<div class="widget-parameter-wrapper-no"></div>')
        }
        if ($(this).find('.price-standard').length>0) {
            $(this).find('.prices').addClass('superPrice').prepend($(this).find('.price-standard')).append($(this).find('.price-save'));
        }
        if (productId) {
            $product.find('.p').append(`
                <div class="customFavorite">
                    <span class="add-to-favorites" data-id="${productId}" data-ids='["${productId}"]'>
                        Přidat do oblíbených
                    </span>
                </div>
            `);
        }
        
    })
        
  }
    
}